export default "__VITE_ASSET__BIoIifBU__"